// Setup-guide progress endpoints. The base URL already carries the `/admin`
// prefix (same convention as SystemEndpoints `/system/modules`), so paths here
// are written without it.
export const SetupGuideEndpoints = {
  state: '/setup-guide/state',
  dismiss: '/setup-guide/dismiss',
  stepSkip: (code: string) => `/setup-guide/steps/${code}/skip`,
};
